export default {
      id: "whalespace_logo-usage",
      viewBox: "0 0 230 32",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#whalespace_logo",
      toString: function () {
        return this.url;
      }
    }